/**
 * (c) 2026, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import AnimationIcon, { AnimationIconProps } from "./AnimationIcon";

const HeartLedIcon = (props: AnimationIconProps) => {
  return (
    <AnimationIcon
      viewBox="0 0 23 22"
      baseCss={{ color: "brand2.500" }}
      {...props}
    >
      <path
        d="M5.70002 0.599609H8.50002C8.70002 0.599609 8.80002 0.799609 8.80002 0.899609V3.69961C8.80002 3.89961 8.60002 3.99961 8.50002 3.99961H5.70002C5.50002 3.99961 5.40002 3.79961 5.40002 3.69961V0.999609C5.40002 0.799609 5.60002 0.699609 5.70002 0.699609"
        fill="currentColor"
      />
      <path
        d="M14.3 0.599609H17.1C17.3 0.599609 17.4 0.799609 17.4 0.899609V3.69961C17.4 3.89961 17.2 3.99961 17.1 3.99961H14.3C14.1 3.99961 14 3.79961 14 3.69961V0.999609C14 0.799609 14.1 0.699609 14.3 0.699609"
        fill="currentColor"
      />
      <path
        d="M1.3 4.90039H4.1C4.3 4.90039 4.4 5.10039 4.4 5.20039V8.00039C4.4 8.20039 4.2 8.30039 4.1 8.30039H1.3C1.1 8.30039 1 8.10039 1 8.00039V5.20039C1 5.00039 1.1 4.90039 1.3 4.90039Z"
        fill="currentColor"
      />
      <path
        d="M5.70002 5.00023H8.50002C8.70002 5.00023 8.80002 5.20023 8.80002 5.30023V8.10023C8.80002 8.30023 8.60002 8.40023 8.50002 8.40023H5.70002C5.50002 8.40023 5.40002 8.20023 5.40002 8.10023V5.30023C5.40002 5.10023 5.60002 4.90023 5.70002 5.00023Z"
        fill="currentColor"
      />
      <path
        d="M9.89997 4.90039H12.7C12.9 4.90039 13 5.10039 13 5.20039V8.00039C13 8.20039 12.8 8.30039 12.7 8.30039H9.89997C9.69997 8.30039 9.59998 8.10039 9.59998 8.00039V5.20039C9.59998 5.00039 9.79997 4.90039 9.89997 4.90039Z"
        fill="currentColor"
      />
      <path
        d="M14.3 4.90039H17.1C17.3 4.90039 17.4 5.10039 17.4 5.20039V8.00039C17.4 8.20039 17.2 8.30039 17.1 8.30039H14.3C14.1 8.30039 14 8.10039 14 8.00039V5.20039C14 5.00039 14.1 4.90039 14.3 4.90039Z"
        fill="currentColor"
      />
      <path
        d="M18.6 5.00023H21.4C21.6 5.00023 21.7001 5.20023 21.7001 5.30023V8.10023C21.7001 8.30023 21.5 8.40023 21.4 8.40023H18.6C18.4 8.40023 18.3 8.20023 18.3 8.10023V5.30023C18.3 5.10023 18.5 4.90023 18.6 5.00023Z"
        fill="currentColor"
      />
      <path
        d="M1.3 9.2998H4.1C4.3 9.2998 4.4 9.4998 4.4 9.5998V12.3998C4.4 12.5998 4.2 12.6998 4.1 12.6998H1.3C1.1 12.6998 1 12.4998 1 12.3998V9.5998C1 9.3998 1.1 9.2998 1.3 9.2998Z"
        fill="currentColor"
      />
      <path
        d="M5.70002 9.2998H8.50002C8.70002 9.2998 8.80002 9.4998 8.80002 9.5998V12.3998C8.80002 12.5998 8.60002 12.6998 8.50002 12.6998H5.70002C5.50002 12.6998 5.40002 12.4998 5.40002 12.3998V9.5998C5.40002 9.3998 5.60002 9.2998 5.70002 9.2998Z"
        fill="currentColor"
      />
      <path
        d="M9.89997 9.2998H12.7C12.9 9.2998 13 9.4998 13 9.5998V12.3998C13 12.5998 12.8 12.6998 12.7 12.6998H9.89997C9.69997 12.6998 9.59998 12.4998 9.59998 12.3998V9.5998C9.59998 9.3998 9.79997 9.2998 9.89997 9.2998Z"
        fill="currentColor"
      />
      <path
        d="M14.3 9.2998H17.1C17.3 9.2998 17.4 9.4998 17.4 9.5998V12.3998C17.4 12.5998 17.2 12.6998 17.1 12.6998H14.3C14.1 12.6998 14 12.4998 14 12.3998V9.5998C14 9.3998 14.1 9.2998 14.3 9.2998Z"
        fill="currentColor"
      />
      <path
        d="M18.6 9.2998H21.4C21.6 9.2998 21.7001 9.4998 21.7001 9.5998V12.3998C21.7001 12.5998 21.5 12.6998 21.4 12.6998H18.6C18.4 12.6998 18.3 12.4998 18.3 12.3998V9.5998C18.3 9.3998 18.5 9.2998 18.6 9.2998Z"
        fill="currentColor"
      />
      <path
        d="M5.70002 13.5996H8.50002C8.70002 13.5996 8.80002 13.7996 8.80002 13.8996V16.6996C8.80002 16.8996 8.60002 16.9996 8.50002 16.9996H5.70002C5.50002 16.9996 5.40002 16.7996 5.40002 16.6996V13.8996C5.40002 13.6996 5.60002 13.5996 5.70002 13.5996Z"
        fill="currentColor"
      />
      <path
        d="M9.89997 13.5996H12.7C12.9 13.5996 13 13.7996 13 13.8996V16.6996C13 16.8996 12.8 16.9996 12.7 16.9996H9.89997C9.69997 16.9996 9.59998 16.7996 9.59998 16.6996V13.8996C9.59998 13.6996 9.79997 13.5996 9.89997 13.5996Z"
        fill="currentColor"
      />
      <path
        d="M14.3 13.5996H17.1C17.3 13.5996 17.4 13.7996 17.4 13.8996V16.6996C17.4 16.8996 17.2 16.9996 17.1 16.9996H14.3C14.1 16.9996 14 16.7996 14 16.6996V13.8996C14 13.6996 14.1 13.5996 14.3 13.5996Z"
        fill="currentColor"
      />
      <path
        d="M9.89997 17.9004H12.7C12.9 17.9004 13 18.1004 13 18.2004V21.0004C13 21.2004 12.8 21.3004 12.7 21.3004H9.89997C9.69997 21.3004 9.59998 21.1004 9.59998 21.0004V18.2004C9.59998 18.0004 9.79997 17.9004 9.89997 17.9004Z"
        fill="currentColor"
      />
    </AnimationIcon>
  );
};

export default HeartLedIcon;
